import React from "react";
import AppLayout from "@/components/AppLayout";
import UsersAdmin from "@/components/UsersAdmin";

/**
 * /users/new — sidebar "New User" entry point. Renders the exact same
 * UsersAdmin component used by Admin → Settings → Users so the workflow is
 * identical (same fields, same role list, same authorized-certifications
 * checkboxes, same save / disable / delete actions). `autoOpen` pops the
 * Create User dialog as soon as the page loads so supervisors land directly
 * on the form.
 */
export default function NewUser() {
  return (
    <AppLayout
      title="New User"
      subtitle="Provision an account — same workflow as Admin → Settings → Users."
    >
      <UsersAdmin autoOpen />
    </AppLayout>
  );
}
